
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Toasted from 'vue-toasted';
import authService from './services/auth';
import registerFilters from './filters'
Vue.use(Toasted, { duration: 4000, position: 'top-right', singleton: true });

Vue.config.productionTip = false;

registerFilters(Vue)

// Reaplica token salvo ao iniciar a aplicação
const savedToken = authService.getToken();
if (savedToken) {
  authService.setToken(savedToken);
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
